import I18n from 'I18n';
import * as React from 'react';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIMicroDateInput from 'UIComponents/dates/UIMicroDateInput';
import UIMicroTimeInput from 'UIComponents/input/UIMicroTimeInput';
import { getMinutesRemainderFromTimestamp, getSimpleDateForTimestamp, getTopOfDateTimestamp, ONE_MINUTE_MS } from 'flow-doctor-lib/utils/dateTimeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MicroTimeRangeInput = ({
  startTimestamp,
  endTimestamp,
  minTime,
  handleTimeChange,
  handleDateChange,
  handleClear,
  disabled,
  timezone,
  view = 'ROW'
}) => {
  const dateStartInput =
  /*#__PURE__*/
  // @ts-expect-error really bad types
  _jsx(UIMicroDateInput, {
    disabled: disabled,
    min: minTime ? getSimpleDateForTimestamp(minTime, timezone) : undefined,
    minValidationMessage: I18n.text('flow-doctor-lib.flows.dateInput.workflowNotCreated'),
    max: endTimestamp && getSimpleDateForTimestamp(endTimestamp, timezone),
    maxValidationMessage: I18n.text('flow-doctor-lib.flows.dateInput.startDateMaxValidation'),
    value: startTimestamp && getSimpleDateForTimestamp(startTimestamp, timezone),
    onChange: ({
      target: {
        value
      }
    }) => {
      // `value` will be null if the user cleared the input
      if (value === null) {
        // TODO: Alert user that this can't be cleared
        handleClear();
      } else {
        handleDateChange('startTimestamp', value);
      }
    }
  });
  const timeStartInput = /*#__PURE__*/_jsx(UIMicroTimeInput, {
    value: startTimestamp && getMinutesRemainderFromTimestamp(startTimestamp, timezone),
    disabled: disabled || !startTimestamp,
    onChange: ({
      target: {
        value
      }
    }) => {
      if (endTimestamp && value * ONE_MINUTE_MS + getTopOfDateTimestamp(startTimestamp, timezone) > endTimestamp) {
        // Don't allow the user to select a starting time later than the end time
        handleTimeChange('startTimestamp', getMinutesRemainderFromTimestamp(endTimestamp, timezone));
      } else {
        handleTimeChange('startTimestamp', value);
      }
    }
  });
  const dateEndInput =
  /*#__PURE__*/
  // @ts-expect-error really bad types
  _jsx(UIMicroDateInput, {
    min: getSimpleDateForTimestamp(startTimestamp, timezone),
    value: endTimestamp && getSimpleDateForTimestamp(endTimestamp, timezone),
    disabled: disabled || !startTimestamp,
    onChange: ({
      target: {
        value
      }
    }) => {
      // `value` will be null if the user cleared the input
      if (value === null) {
        handleClear();
      } else {
        handleDateChange('endTimestamp', value);
      }
    }
  });
  const timeEndInput = /*#__PURE__*/_jsx(UIMicroTimeInput, {
    value: endTimestamp && getMinutesRemainderFromTimestamp(endTimestamp, timezone),
    disabled: disabled || !endTimestamp,
    onChange: ({
      target: {
        value
      }
    }) => {
      if (startTimestamp && value * ONE_MINUTE_MS + getTopOfDateTimestamp(endTimestamp, timezone) < startTimestamp) {
        // Don't allow the user to select a starting time later than the end time
        handleTimeChange('endTimestamp', getMinutesRemainderFromTimestamp(startTimestamp, timezone));
      } else {
        handleTimeChange('endTimestamp', value);
      }
    }
  });
  if (view === 'ROW') {
    return /*#__PURE__*/_jsxs(UIFlex, {
      gap: 8,
      align: "center",
      justify: "around",
      children: [/*#__PURE__*/_jsx(UIHelpIcon, {
        title: timezone === 'UTC' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.dateInput.betweenTimeTooltip.utc"
        }) : timezone === 'PORTAL_TZ' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.dateInput.betweenTimeTooltip.portalTz"
        }) : timezone === 'USER_TZ' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.dateInput.betweenTimeTooltip.userTz"
        }) : null,
        tooltipPlacement: "top"
      }), /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.dateInput.filterLabel"
        })
      }), dateStartInput, timeStartInput, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.global.dateTimeSearch.to"
      }), dateEndInput, timeEndInput]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: "m-bottom-2",
      justify: "start",
      children: [/*#__PURE__*/_jsx(UIBox, {
        basis: 150,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.dateTimeSearch.dateRange"
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 320,
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "start",
          children: [/*#__PURE__*/_jsx(UIBox, {
            basis: 120,
            children: dateStartInput
          }), /*#__PURE__*/_jsx(UIBox, {
            basis: 30,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              useGap: true,
              message: "flow-doctor-lib.global.dateTimeSearch.to"
            })
          }), /*#__PURE__*/_jsx(UIBox, {
            basis: 120,
            children: dateEndInput
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(UIFlex, {
      justify: "start",
      children: [/*#__PURE__*/_jsxs(UIBox, {
        basis: 150,
        children: [timezone === 'UTC' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.dateTimeSearch.timeRange.utc"
        }), timezone === 'PORTAL_TZ' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.dateTimeSearch.timeRange.portal"
        }), timezone === 'USER_TZ' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.global.dateTimeSearch.timeRange.user"
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 320,
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "start",
          children: [/*#__PURE__*/_jsx(UIBox, {
            basis: 143,
            children: timeStartInput
          }), /*#__PURE__*/_jsx(UIBox, {
            basis: 30,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              useGap: true,
              message: "flow-doctor-lib.global.dateTimeSearch.to"
            })
          }), /*#__PURE__*/_jsx(UIBox, {
            basis: 120,
            children: timeEndInput
          })]
        })
      })]
    })]
  });
};
export default MicroTimeRangeInput;